<template>
  <div class="quality-recommend">
    <div class="slider-banner swiper">
      <swiper class="swiper-wrapper" :options="RecommendSwiper">
        <swiperSlide class="swiper-slide" v-for="(item, index) in imgUrls" :key="index">
          <img :src="item.img" class="slide-image" />
        </swiperSlide>
      </swiper>
      <div class="swiper-pagination"></div>
    </div>
    <div class="title acea-row row-center-wrapper">
      <div class="line"></div>
      <div class="name">
        <span class="iconfont" :class="icon"></span>{{ name }}
      </div>
      <div class="line"></div>
    </div>
    <GoodList :good-list="goodsList" :is-sort="false" v-show="type == 1"></GoodList>
    <DiscountList :good-list="goodsList" :is-sort="false" v-show="type == 2"></DiscountList>
  </div>
</template>
<script>
  import {
    swiper,
    swiperSlide
  } from "vue-awesome-swiper";
  import "@assets/css/swiper.min.css";
  import GoodList from "@components/GoodList";
  import DiscountList from "@components/DiscountList";
  import {
    getGroomList
  } from "@api/store";
  import {
    getDiscountList
  } from "@api/activity";
  export default {
    name: "HotNewGoods",
    components: {
      swiper,
      swiperSlide,
      GoodList,
      DiscountList
    },
    props: {},
    data: function () {
      return {
        type: null,
        imgUrls: [],
        goodsList: [],
        name: "",
        icon: "",
        RecommendSwiper: {
          pagination: {
            el: ".swiper-pagination",
            clickable: true
          },
          autoplay: {
            disableOnInteraction: false,
            delay: 2000
          },
          loop: true,
          speed: 1000,
          observer: true,
          observeParents: true
        }
      };
    },
    mounted: function () {
      this.type = this.$route.params.type;
      this.titleInfo();
      this.getIndexGroomList();
      // this.getDiscountList();
    },
    methods: {
      titleInfo: function () {
        let type = this.$route.params.type;
        if (type === "1") {
          this.name = "精品推荐";
          this.icon = "icon-jingpintuijian";
          document.title = "精品推荐";
        } else if (type === "2") {
          this.name = "打折优惠";
          this.icon = "icon-remen";
          document.title = "打折优惠";
        } else if (type === "3") {
          this.name = "首发新品";
          this.icon = "icon-xinpin";
          document.title = "首发新品";
        }
      },
      getIndexGroomList: function () {
        let that = this;
        if (this.type == 2) {
          // console.log("打折优惠");
          getDiscountList()
            .then(res => {
              // console.log(res);
              that.goodsList = res.data[0].list;
            })
            .catch(function (res) {
              this.$dialog.toast({
                mes: res.msg
              });
            });
        }
        getGroomList(this.type)
          .then(res => {
            that.imgUrls = res.data.banner;
          })
          .catch(function (res) {
            this.$dialog.toast({
              mes: res.msg
            });
          });
      }
    }
  };
</script>
